<template>
  <div style="position:relative;">
    <h3 style="margin:15px;text-align:center;">
      Daily Close/Open and Pre Order
      <v-btn
        icon
        absolute
        v-if="!isEditStoreList"
        @click="editDailyPreOrder()"
        style="top:-5px;right:15px;"
      >
        <v-icon color="black">edit</v-icon>
      </v-btn>
    </h3>
    <hr class="line-hr" />
    <v-layout row wrap>
      <v-flex xs12 sm7 md12 lg7>
        <editStoreDaily
          :dialog="daily_dialog"
          @setDialog="daily_dialog = $event"
          :timeItems="timeItems"
          :store_preorder="store_preorder"
        />
        <v-layout row justify-start v-for="item in timeItems" :key="item.days">
          <v-flex xs2 class="mb-2">
            <span class="style-title-detail">{{item.days}}</span>
          </v-flex>
          <v-flex xs1>
            <div
              v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase()] != null && store_detail.store_time['store_time_close_' + item.days.toLowerCase()] != null"
            >
              <v-icon>access_time</v-icon>
            </div>
            <div
              v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase()] == null || store_detail.store_time['store_time_close_' + item.days.toLowerCase()] == null"
            >
              <v-icon color="red">close</v-icon>
            </div>
            <div style="padding-bottom:10px;">
              <v-flex
                v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase() +'2'] != null && store_detail.store_time['store_time_close_' + item.days.toLowerCase() + '2'] != null"
              >
                <v-icon>access_time</v-icon>
              </v-flex>
            </div>
          </v-flex>
          <v-flex xs6>
            <div
              v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase()] != null && store_detail.store_time['store_time_close_' + item.days.toLowerCase()] != null"
            >
              <span
                class="style-data-detail"
              >{{store_detail.store_time['store_time_open_' + item.days.toLowerCase()].substring(0,5)}}</span>
              <span class="style-title-detail">-</span>
              <span
                class="style-data-detail"
              >{{store_detail.store_time['store_time_close_' + item.days.toLowerCase()].substring(0,5)}}</span>
            </div>
            <div
              v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase()] == null || store_detail.store_time['store_time_close_' + item.days.toLowerCase()] == null"
            >
              <span class="style-data-detail">Close day</span>
            </div>
            <div style="padding-bottom:10px;">
              <v-flex
                v-if="store_detail.store_time['store_time_open_' + item.days.toLowerCase() +'2'] != null && store_detail.store_time['store_time_close_' + item.days.toLowerCase() + '2'] != null"
              >
                <span
                  class="style-data-detail"
                >{{store_detail.store_time['store_time_open_' + item.days.toLowerCase() +'2'].substring(0,5)}}</span>
                <span class="style-title-detail">-</span>
                <span
                  class="style-data-detail"
                >{{store_detail.store_time['store_time_close_' + item.days.toLowerCase() + '2'].substring(0,5)}}</span>
              </v-flex>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm5 md12 lg5>
        <div
          v-if="store_detail.store_time.store_time_preorder_time == null && store_detail.store_time.store_time_preorder_day == null && store_detail.store_time.store_time_preorder_daytime == null"
        >
          <span class="style-title-detail text-xs-center">Store Preorder :</span>
          <span class="style-data-detail">No</span>
        </div>
        <div
          class="style-title-detail"
          v-if="store_detail.store_time.store_time_preorder_time != null"
        >
          <v-icon>motorcycle</v-icon>Delivery in
          <span
            class="style-data-detail"
          >{{store_detail.store_time.store_time_preorder_time}}</span>
          Hour
        </div>
        <div
          class="style-title-detail"
          v-if="store_detail.store_time.store_time_preorder_day != null"
        >
          <v-icon>motorcycle</v-icon>Delivery in
          <span
            class="style-data-detail"
          >{{store_detail.store_time.store_time_preorder_day}}</span>
          Day
        </div>
        <div
          class="style-title-detail"
          v-if="store_detail.store_time.store_time_preorder_daytime != null"
        >
          <v-icon>motorcycle</v-icon>Delivery in
          <span
            class="style-data-detail"
          >{{store_detail.store_time.store_time_preorder_daytime[0]}}</span>
          <div style="padding-left:73px;">
            and
            <span
              class="style-data-detail"
            >{{store_detail.store_time.store_time_preorder_daytime[1]}}</span>
            <br />and
            <span
              class="style-data-detail"
            >{{store_detail.store_time.store_time_preorder_daytime[2]}}</span>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import editStoreDaily from "../EditStore/EditStoreDaily";
import { mapGetters } from "vuex";
export default {
  props: ["store_detail"],
  components: {
    editStoreDaily,
  },
  data() {
    return {
      daily_dialog: false,
      timeItems: [
        {
          days: "Mon",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Tue",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Wed",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Thu",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Fri",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Sat",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Sun",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
      ],
      store_preorder: {
        preOrderGroup: "0",
        store_time_preorder_day: null,
        store_time_preorder_daytime: [],
        store_time_preorder_time: {
          HH: "",
          mm: "",
          ss: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    splitTime(days) {
      for (let key in this.timeItems) {
        if (days == this.timeItems[key].days) {
          if (
            this.store_detail.store_time[
              "store_time_open_" + days.toLowerCase()
            ] != null
          ) {
            let open_time_1 = this.store_detail.store_time[
              "store_time_open_" + days.toLowerCase()
            ].split(":");
            this.timeItems[key].start_time.HH = open_time_1[0];
            this.timeItems[key].start_time.mm = open_time_1[1];
            this.timeItems[key].start_time.ss = open_time_1[2];
          }
          if (
            this.store_detail.store_time[
              "store_time_close_" + days.toLowerCase()
            ] != null
          ) {
            let close_time_1 = this.store_detail.store_time[
              "store_time_close_" + days.toLowerCase()
            ].split(":");
            this.timeItems[key].end_time.HH = close_time_1[0];
            this.timeItems[key].end_time.mm = close_time_1[1];
            this.timeItems[key].end_time.ss = close_time_1[2];
          }
          if (
            this.store_detail.store_time[
              "store_time_open_" + days.toLowerCase() + "2"
            ] != null
          ) {
            this.timeItems[key].more = true;
            let open_time_2 = this.store_detail.store_time[
              "store_time_open_" + days.toLowerCase() + "2"
            ].split(":");
            this.timeItems[key].start_time2.HH = open_time_2[0];
            this.timeItems[key].start_time2.mm = open_time_2[1];
            this.timeItems[key].start_time2.ss = open_time_2[2];
          }
          if (
            this.store_detail.store_time[
              "store_time_close_" + days.toLowerCase() + "2"
            ] != null
          ) {
            this.timeItems[key].more = true;
            let close_time_2 = this.store_detail.store_time[
              "store_time_close_" + days.toLowerCase() + "2"
            ].split(":");
            this.timeItems[key].end_time2.HH = close_time_2[0];
            this.timeItems[key].end_time2.mm = close_time_2[1];
            this.timeItems[key].end_time2.ss = close_time_2[2];
          }
        }
      }
    },
    takePreorder() {
      if (this.store_detail.store_time.store_time_preorder_time != null) {
        this.store_preorder.preOrderGroup = "1";
        let time = this.store_detail.store_time.store_time_preorder_time.split(
          ":"
        );
        this.store_preorder.store_time_preorder_time.HH = time[0];
        this.store_preorder.store_time_preorder_time.mm = time[1];
        this.store_preorder.store_time_preorder_time.ss = time[2];
      } else if (this.store_detail.store_time.store_time_preorder_day != null) {
        this.store_preorder.store_time_preorder_day = this.store_detail.store_time.store_time_preorder_day;
        this.store_preorder.preOrderGroup = "2";
      } else if (
        this.store_detail.store_time.store_time_preorder_daytime != null
      ) {
        this.store_preorder.store_time_preorder_daytime = this.store_detail.store_time.store_time_preorder_daytime;
        this.store_preorder.preOrderGroup = "3";
      } else {
        this.store_preorder.preOrderGroup = "0";
      }
    },
    resetForm() {
      (this.timeItems = [
        {
          days: "Mon",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Tue",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Wed",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Thu",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Fri",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Sat",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
        {
          days: "Sun",
          more: false,
          start_time: { HH: "", mm: "", ss: "" },
          end_time: { HH: "", mm: "", ss: "" },
          start_time2: { HH: "", mm: "", ss: "" },
          end_time2: { HH: "", mm: "", ss: "" },
        },
      ]),
        (this.store_preorder = {
          preOrderGroup: "0",
          store_time_preorder_day: null,
          store_time_preorder_daytime: [],
          store_time_preorder_time: {
            HH: "",
            mm: "",
            ss: "",
          },
        });
    },
    editDailyPreOrder() {
      this.resetForm();
      for (let key in this.timeItems) {
        this.splitTime(this.timeItems[key].days);
      }
      this.daily_dialog = true;
      this.takePreorder();
    },
  },
};
</script>

<style>
.line-hr {
  margin-bottom: 15px;
  margin-right: 15px;
}
.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 5px;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0;
}
.v-text-field--outline .v-input__slot {
  border-radius: 2px;
}
.v-text-field--outline .v-input__slot {
  min-height: 20px;
}
.v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0 6px;
}
.theme--light.v-text-field--outline .v-input__slot {
  border: 2px solid #d2d2d2;
}
.v-text-field--outline .v-input__slot {
  border-radius: 1px;
}
.timePicker {
  margin-top: 15px;
}
.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}
.time-picker input.display-time {
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}
</style>
